<mat-card class="components-card" [ngClass]="{'readonly-layout': isReadOnly, 'editable-layout': !isReadOnly}">
    <mat-card-content>
        <!-- Non-readonly version -->
        <ng-container *ngIf="!isReadOnly">
            <div class="d-flex align-items-center component-header" *ngIf="componentCardLabel">
                <div class="flex-fill text-center">
                    <h6 class="m-0 blue-text">{{ componentCardLabel }}s ({{ components?.length || 0 }})</h6>
                </div>
                <div class="float-end button-position" *ngIf="showAddButton">
                    <button mat-raised-button class="add-modifier-btn" type="button" (click)="onAddComponent()"
                            [matTooltip]="'Add one or more ' + componentCardLabel?.toLowerCase() + 's for this ' + (isItem ? 'item' : isItemGrouping ? 'item group' : isModifierGrouping ? 'modifier group' : '')">
                        <mat-icon>add</mat-icon>
                        Add
                    </button>
                </div>
            </div>
            <mat-divider class="card-divider" *ngIf="componentCardLabel"></mat-divider>
            <div class="d-flex justify-content-center align-items-center" *ngIf="componentCardLabel">
                <div *ngIf="components?.length > 0; else noComponents" style="width: 100%;">
                    <div class="component-item" *ngFor="let component of components">
                        <div class="component-row" (click)="onViewComponent(component)">
                            <span class="component-tag">{{ getComponentTag(component) }}</span>
                        </div>
                    </div>
                </div>
                <ng-template #noComponents>
                    <div class="d-flex justify-content-center align-items-center">
                        <p class="mt-4 text-center">{{ variation?.variationLabel || variation?.variationTag || 'This variation' }}
                            has no {{ componentCardLabel?.toLowerCase() }}s</p>
                    </div>
                </ng-template>
            </div>
        </ng-container>

        <!-- Readonly version -->
        <ng-container *ngIf="isReadOnly && componentCardLabel">
            <mat-tab-group>
                <mat-tab [label]="componentCardLabel + 's  (' + (components?.length || 0) + ')'">
                    <div class="d-flex justify-content-center align-items-center">
                        <div *ngIf="components?.length > 0; else noComponentsReadonly" style="width: 100%;">
                            <div class="component-item" *ngFor="let component of components">
                                <div class="component-row">
                                    <span class="component-tag">{{ getComponentTag(component) }}</span>
                                </div>
                            </div>
                        </div>
                        <ng-template #noComponentsReadonly>
                            <div class="d-flex justify-content-center align-items-center">
                                <p class="mt-4 text-center">{{ itemName }} has no components</p>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
    </mat-card-content>
</mat-card>
